import get from 'lodash/get';
import Vue, { DirectiveOptions } from 'vue';
import { $http } from '../app.config';
import { africaOptions, dataLayer } from '../globals';
import { uid, urlParam } from '../helpers/utils';

const dataLayerProcess = (tId: string, formEvent: string): void => {
    $http.get(africaOptions.api.routes.datalayears.index + '/' + tId).then((response: any) => {
        const success = get(response, 'data.success', false);
        if (!success) {
            return;
        }
        const { data } = get(response, 'data.body', {});

        let isExists = false;
        dataLayer.map((i) => {
            if (i.event === formEvent) {
                i.form_value = data.value;
                isExists = true;
            }
        });

        if (!isExists) {
            dataLayer.push({
                event: formEvent,
                form_name: data.name,
                form_email: data.email,
                form_phone: data.phone,
                form_value: data.value,
                form_currency: data.currency,
                form_id: data.id,
            });
        }
    });
};

const dataForDatalayer: DirectiveOptions = {
    bind(): void {
        let tId = urlParam('tid', false);
        let formEvent = 'form_get_quote';
        if (!tId) {
            tId = urlParam('booktid', false);
            formEvent = 'form_booking_confirmation';
            if (!tId || tId === 'undefined') {
                return;
            }
        }
        dataLayerProcess(tId, formEvent);
    },
    update: (el, binding): void => {
        const tId = urlParam('tid', false);
        const formEvent = 'form_get_quote';
        if (!tId) {
            return;
        }
        dataLayerProcess(tId, formEvent);
    },
};

export default dataForDatalayer;



// WEBPACK FOOTER //
// ./src/directives/dataForDatalayer.ts